import React, { useContext, useEffect } from 'react';

import WebinarsContext from 'webinars/context';

import WebinarDescription from 'webinars/components/WebinarDescription';
import WebinarHost from 'webinars/components/WebinarHost';
import WebinarVideo from 'webinars/components/WebinarVideo';
import UpcomingWebinars from 'webinars/components/UpcomingWebinars';

import ConfirmationPageDetails from 'shared/components/ConfirmationPageDetails';
import ComputerChat from 'assets/images/computer-chat.svg';

// Helpers
import { getPageContent } from './helpers';
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';

import BravelyData from 'utils/data';

import './styles';
import { isPro } from 'utils/role';

const {
  webinars: { VIEW_WEBINAR_CONTENT_PAGE },
} = mixpanelEvents;

const WebinarWatchPage = () => {
  const { webinar } = useContext(WebinarsContext);
  const { name, encodedId, recordingUrl } = webinar;

  const { bookCtaProps, shareCtaProps } = getPageContent(webinar);

  const ctaProps =
    BravelyData('hasUpcomingSession') || isPro() ? shareCtaProps : bookCtaProps;

  useEffect(() => {
    const {
      button: {
        props: { text },
      },
    } = ctaProps || {};
    mixpanelTrack(VIEW_WEBINAR_CONTENT_PAGE, {
      encodedId,
      name,
      cta: text,
    });
  }, []);

  return (
    <div className="webinar-watch-page-container">
      <div className="main-content-wrapper app-centered two-columns-wrapper">
        <div className="details-wrapper">
          <div className="main-details">
            <WebinarVideo title={name} videoURL={recordingUrl} />
            <WebinarDescription />
          </div>
          <div className="side-details">
            <WebinarHost />
            <UpcomingWebinars />
            <ConfirmationPageDetails
              ctaProps={ctaProps}
              backgroundImg={ComputerChat}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebinarWatchPage;
